import clsx from 'clsx';
import styles from './ArrangeBox.module.scss';

function ArrangeBox({ children, className, box, ...rest }) {
    return box.gone ? (
        <div {...rest} className={clsx(styles.box, styles.gone, className)}>
            {box.text}
        </div>
    ) : (
        <div {...rest} className={clsx(styles.box, className)}>
            {box.text}
        </div>
    );
}
export default ArrangeBox;
